/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_EntertainmentInputs */

const en_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entertainment`)
};

const fr_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divertissement`)
};

const de_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung`)
};

const it_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divertimento`)
};

const ru_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развлечение`)
};

const es_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretenimiento`)
};

const zh_cn2_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`娱乐`)
};

const ja_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンターテインメント`)
};

const hi_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मनोरंजन`)
};

const pt_pt2_subtitle_export_keyword_entertainment = /** @type {(inputs: Subtitle_Export_Keyword_EntertainmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretenimento`)
};

/**
* | output |
* | --- |
* | "Entertainment" |
*
* @param {Subtitle_Export_Keyword_EntertainmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_entertainment = /** @type {((inputs?: Subtitle_Export_Keyword_EntertainmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_EntertainmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_entertainment(inputs)
	if (locale === "de") return de_subtitle_export_keyword_entertainment(inputs)
	if (locale === "it") return it_subtitle_export_keyword_entertainment(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_entertainment(inputs)
	if (locale === "es") return es_subtitle_export_keyword_entertainment(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_entertainment(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_entertainment(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_entertainment(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_entertainment(inputs)
	return en_subtitle_export_keyword_entertainment(inputs)
});